module.exports = __webpack_public_path__ + "img/Madagascar.adfaf5ae.svg";